<template>
  <div class="anniversary-page">
    <!-- WORKAHOLICS 入职祝福 - 只显示图片 -->
    <div v-if="blessType === 'WORKAHOLICS'" class="workaholics-page">
      <img :src="contentImage" alt="欢迎加入" class="workaholics-image" />
    </div>

    <!-- 其他类型祝福 -->
    <template v-else>
      <!-- 弹幕 -->
      <div class="barrage-box">
        <div
          class="barrage-item"
          v-for="(item, idx) in displayBarrageArr"
          :key="idx"
          :style="getBarrageStyle(idx)"
        >
          {{ formatBarrageText(item) }}
        </div>
      </div>

      <!-- 主体内容区域 -->
      <div class="main-container">
        <div class="content-section">
          <img :src="contentImage" alt="祝福图片" class="content-image" />
          <div class="main-content">
            <p class="user-name">{{ userName }}</p>
            <p class="content-text">
              {{ blessingConfig.selfContentTemplate || "" }}
            </p>
            <p class="sign">- 雷士照明 -</p>
          </div>
        </div>

        <!-- 同事祝福列表 -->
        <div class="bless-container">
          <div class="bless-header">
            <span class="bless-title">来自同事祝福</span>
            <span class="bless-count">{{ barrageArr.length }}条</span>
          </div>
          <div class="bless-list">
            <div class="bless-item" v-for="(item, i) in barrageArr" :key="i">
              <div class="bless-avatar">
                <img
                  v-if="item.senderAvatar"
                  :src="item.senderAvatar"
                  alt=""
                  class="avatar-img"
                  @error="handleAvatarError(item)"
                />
                <span v-else class="avatar-text">{{ getAvatarText(item) }}</span>
              </div>
              <div class="bless-content">
                <div class="bless-sender">{{ getSenderName(item) }}</div>
                <div class="bless-text">{{ getContent(item) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "AnniversaryPage",
  data() {
    return {
      userName: "XXX",
      blessType: "BIRTHDAY",
      receiverNo: "",
      evenEmpOrgId: "",
      evenDate: "",
      barrageArr: [],
      isLoading: false,
      maxBarrageCount: 4,
      maxCommentCount: 30,
      blessingConfig: {},
      barrageTimer: null, // 新增
      // 敏感词列表
      sensitiveWords: [
        // 辱骂性词汇
        '操', '草', '靠', '妈的', '他妈的', '你妈', '尼玛', '卧槽', '滚',
        '傻逼', '傻B', 'SB', '垃圾', '废物', '脑残', '智障', '脑瘫',
        '去死', '该死', '混蛋', '畜生', '狗日的', '操你妈', 'Fuck',
        // 低俗色情
        '色情', '黄色', 'AV', '裸', '性交', '做爱', '手淫', '嫖娼',
        '卖淫', '约炮', '露点', '自慰', '性用品', '三级片', '成人',
        // 广告推广
        '微信号', '微信', 'QQ', '电话', '手机号', '二维码', '加我',
        '联系我', '私聊', '推广', '广告', '代理', '加盟', '优惠',
        '打折', '促销', '免费', '领取', '红包', '返利',
        // 违法违规
        '赌博', '赌', '六合彩', '毒品', '大麻', '冰毒', '枪支',
        '暴力', '杀人', '抢劫', '诈骗', '传销', '邪教',
      ],
    };
  },
  computed: {
    // 背景图全铺满（关键修复）
    bannerBgStyle() {
      const bgMap = {
        BIRTHDAY: require("@/assets/medal/quaquaka/bestWishBg.jpg"),
        WORKAHOLICS: require("@/assets/medal/quaquaka/workaholics.jpg"),
        ANNIVERSARY: require("@/assets/medal/quaquaka/bestWishBg.jpg"),
      };
      const imageUrl = bgMap[this.blessType] || bgMap.ANNIVERSARY;
      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed", // 保证滚动时背景也铺满
      };
    },
    contentImage() {
      const bgMap = {
        BIRTHDAY: require("@/assets/medal/quaquaka/birthday.jpg"),
        WORKAHOLICS: require("@/assets/medal/quaquaka/workaholics.jpg"),
        ANNIVERSARY: require("@/assets/medal/quaquaka/anniversary.jpg"),
      };
      return bgMap[this.blessType] || bgMap.ANNIVERSARY;
    },
    displayBarrageArr() {
      return this.barrageArr.slice(0, this.maxBarrageCount);
    },
  },

  created() {
    this.initData();
    // 自动循环打乱弹幕，实现无限滚动
    this.barrageTimer = setInterval(() => {
      this.barrageArr = [...this.barrageArr.sort(() => Math.random() - 0.5)];
    }, 15000);
  },

  beforeDestroy() {
    clearInterval(this.barrageTimer); // 清理定时器
  },
  methods: {
    initData() {
      const { evenEmp, type, evenEmpNo, evenEmpOrgId, evenDate } =
        this.$route?.query || {};
      this.userName = evenEmp || "";
      this.blessType = type || "BIRTHDAY";
      this.receiverNo = evenEmpNo || "";
      this.evenEmpOrgId = evenEmpOrgId || "";
      this.evenDate = evenDate || "";

      if (this.receiverNo) {
        this.fetchBlessingComment();
      } else {
        this.setDefaultBarrage();
      }
    },
    async fetchBlessingComment() {
      this.isLoading = true;
      try {
        const res = await api.queryBlessingComment({
          blessingType: this.blessType,
          blessingYear: new Date().getFullYear().toString(),
          receiverNo: this.receiverNo,
          needComment: true,
          status: 1, //祝福评论开启状态
        });
        if (res.code == 200) {
          const apiComments = res.data?.hsBlessingCommentList || [];
          // 过滤敏感词
          const filteredComments = this.filterBarrageList(apiComments);
          this.barrageArr = [...filteredComments, ...this.getDefaultBarrage()];
          if (
            res.data?.hsBlessingConfigList &&
            res.data.hsBlessingConfigList.length > 0
          ) {
            this.blessingConfig = res.data.hsBlessingConfigList[0] || {};
          }
        } else {
          this.barrageArr = this.getDefaultBarrage();
        }
      } catch (error) {
        console.error("获取祝福数据失败:", error);
        this.barrageArr = this.getDefaultBarrage();
      } finally {
        this.isLoading = false;
      }
    },
    getDefaultBarrage() {
      const birthdayBlessings = [
        {
          senderName: "雷士照明",
          content: "同在雷士相伴前行，愿灯光岁岁暖心，祝你生日快乐，万事顺遂！",
        },
        // {
        //   senderName: "雷士照明",
        //   content: "以雷士之光赴美好生辰，愿生活常亮暖意，岁岁平安喜乐。",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "共事雷士，灯火相伴，祝同事生辰安康，前路熠熠生辉。",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "聚力雷士，光影同行，祝生辰快乐，日子熠熠发光。",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "扎根雷士，灯火伴朝夕，愿岁岁皆美好，生日快乐。",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "共筑雷士光芒，愿生辰顺遂，生活处处有光亮。",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "携手雷士并肩，灯光见证美好，祝你生日快乐。",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "雷士暖光相伴，愿生辰喜乐，前程璀璨明亮。",
        // },
      ];

      const workaholicsBlessings = [
        {
          senderName: "雷士照明",
          content:
            "欢迎加入雷士照明大家庭！愿你在这里开启新的征程，与公司共同成长，共创美好未来！",
        },
        // {
        //   senderName: "雷士照明",
        //   content: "新的起点，新的征程，愿你在雷士绽放光彩，成就梦想！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "热烈欢迎新同事！愿我们携手共进，共创辉煌！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "加入雷士，点亮未来！祝你工作顺利，大展宏图！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "欢迎加入雷士大家庭，愿你在这里收获成长与快乐！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "新的旅程从雷士开始，愿你乘风破浪，再创佳绩！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "携手雷士，共创美好明天！祝你工作愉快，步步高升！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "欢迎新伙伴加入，让我们一起为雷士的明天努力奋斗！",
        // },
      ];

      const anniversaryBlessings = [
        {
          senderName: "雷士照明",
          content: "时光荏苒，岁月如歌，感谢一路相伴！愿你初心不改，砥砺前行！",
        },
        // {
        //   senderName: "雷士照明",
        //   content: "风雨同舟，携手同行，祝周年快乐，再创辉煌！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "与雷士同行的日子，每一刻都值得铭记！祝周年快乐！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "岁月见证成长，奋斗成就未来！祝周年快乐，前程似锦！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "感恩有你，一路相伴！祝周年快乐，愿我们继续携手前行！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "时光不负有心人，愿你在雷士的每一天都精彩纷呈！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "周年纪念，是过去的总结，更是未来的起点！加油！",
        // },
        // {
        //   senderName: "雷士照明",
        //   content: "与公司共赴美好新征程，祝周年快乐，再创佳绩！",
        // },
      ];

      const blessingsMap = {
        BIRTHDAY: birthdayBlessings,
        WORKAHOLICS: workaholicsBlessings,
        ANNIVERSARY: anniversaryBlessings,
      };
      return blessingsMap[this.blessType] || birthdayBlessings;
    },
    getBarrageStyle(idx) {
      const topList = [5, 12, 20, 28, 36, 44, 52, 60];
      // 速度：慢一点更优雅
      const duration = 15 + Math.random() * 8;
      // ✅ 核心：延迟递增，不会一进来就全弹出来
      const delay = idx * 1.2 + Math.random() * 1.5;

      return {
        top: topList[idx % topList.length] + "%",
        animationDuration: duration + "s",
        animationDelay: delay + "s",
        fontSize: "16px", // ✅ 字体变小
        opacity: 0.8,
        zIndex: 999,
      };
    },
    formatBarrageText(item) {
      const sender = item.senderName || "同事";
      const content = this.filterSensitiveWords(item.content || "生日快乐！");
      return `${sender}：${content}`;
    },
    // 敏感词过滤方法
    filterSensitiveWords(text) {
      if (!text) return "";
      let result = text;
      this.sensitiveWords.forEach((word) => {
        const regex = new RegExp(word, "gi");
        result = result.replace(regex, "*".repeat(word.length));
      });
      return result;
    },
    // 过滤整个弹幕数组中的敏感内容
    filterBarrageList(list) {
      return list.filter((item) => {
        const content = item.content || "";
        // 检查是否包含敏感词
        const hasSensitiveWord = this.sensitiveWords.some((word) => {
          return content.includes(word);
        });
        // 过滤掉包含敏感词的祝福
        return !hasSensitiveWord;
      });
    },
    getAvatarText(item) {
      const name = item.senderName || item || "同事";
      return name.slice(0, 1);
    },
    handleAvatarError(item) {
      item.senderAvatar = null;
    },
    getSenderName(item) {
      return item.senderName || "同事";
    },
    getContent(item) {
      const content = item.content || "祝你生日快乐！";
      return this.filterSensitiveWords(content);
    },
  },
};
</script>

<style lang="scss" scoped>
/* ========== 基础重置 ========== */
* {
  box-sizing: border-box;
}

.anniversary-page {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 50%, #bbf7d0 100%);
}

/* ========== 弹幕  ========== */
.barrage-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 999;
  overflow: hidden;

  .barrage-item {
    position: absolute;
    white-space: nowrap;
    font-weight: 500;
    color: #fff;
    padding: 4px 12px; // 内边距缩小，更精致
    border-radius: 40px;
    background: rgba(34, 197, 94, 0.7);
    backdrop-filter: blur(8px);
    box-shadow: 0 3px 8px rgba(34, 197, 94, 0.2);
    border: 0.5px solid rgba(255, 255, 255, 0.15);
    animation: barrageRun linear infinite;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
      sans-serif;
    will-change: transform;
  }
}

@keyframes barrageRun {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-120%);
  }
}
/* ========== 主容器布局 ========== */
.main-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 60px;
  box-sizing: border-box;
}

.content-section {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 32px;
  overflow: hidden;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.12);
  margin-top: 100px;
}

.content-image {
  width: 100%;
  height: auto;
  display: block;
}

.main-content {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(6px);
  padding: 35px 30px;
}

.user-name {
  font-size: 34px;
  font-weight: 700;
  color: #16a34a;
  margin: 0 0 14px;
  letter-spacing: 2px;
  text-align: left;
}

.content-text {
  font-size: 24px;
  color: #333;
  line-height: 1.9;
  margin: 0 0 20px;
  font-weight: 500;
  letter-spacing: 1px;
}

.sign {
  font-size: 22px;
  color: #777;
  text-align: right;
  margin: 0;
  font-weight: 500;
  font-style: italic;
  letter-spacing: 1px;
}

/* ========== 同事祝福列表 暖色渐变主题 ========== */
.bless-container {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.06);
  margin-top: 30px;
  width: 100%;
  max-width: 600px;
}

.bless-header {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  /* 暖色渐变 */
  // background: linear-gradient(135deg, #f59e0b, #f97316);
  background-color: rgba(129, 194, 104);

  .bless-icon {
    font-size: 28px;
    margin-right: 12px;
  }
  .bless-title {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    flex: 1;
  }
  .bless-count {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(0, 0, 0, 0.15);
    padding: 6px 14px;
    border-radius: 24px;
  }
}

.bless-list {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
    background: #f0fdf4;
  }
  &::-webkit-scrollbar-thumb {
    background: #4ade80;
    border-radius: 10px;
  }
}

.bless-item {
  display: flex;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid rgba(34, 197, 94, 0.1);
  transition: all 0.2s ease;
  &:last-child {
    border-bottom: none;
  }
  &:active {
    background: rgba(34, 197, 94, 0.06);
  }
}

.bless-avatar {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  /* 头像绿色渐变 */
  background-color: rgba(129, 194, 104);
  display: flex;
  align-items: center;
  justify-content: center;
  // box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  overflow: hidden;

  .avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
  .avatar-text {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
  }
}

.bless-content {
  flex: 1;
  min-width: 0;

  .bless-sender {
    font-size: 24px;
    font-weight: 600;
    // color: #059669;
    margin-bottom: 6px;
  }
  .bless-text {
    font-size: 24px;
    color: #2c3e50;
    line-height: 1.6;
    word-break: break-all;
  }
}

/* WORKAHOLICS 入职祝福样式 - 只显示图片 */
.workaholics-page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.workaholics-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 移动端适配 */
@media screen and (max-width: 600px) {
  .main-container {
    padding: 20px 12px 50px;
  }
  .content-section {
    width: 95%;
    margin-top: 80px;
  }
  .bless-container {
    width: 100%;
  }
  .bless-header {
    padding: 16px 20px;
    .bless-title {
      font-size: 26px;
    }
    .bless-count {
      font-size: 20px;
    }
  }
  .bless-item {
    padding: 14px 20px;
    gap: 12px;
  }
  .bless-avatar {
    width: 44px;
    height: 44px;
  }
}
</style>